import React from 'react';
import PropTypes from 'prop-types';
import BlogPage from 'components/BlogPage';

function Blog({ pathContext }) {
  return <BlogPage data={pathContext} />;
}

Blog.propTypes = {
  pathContext: PropTypes.shape({}).isRequired,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/templates/Blog.js